import * as yup from 'yup'

const schema = () =>
  yup.object({
    title: yup.string().required(),
    responsibleId: yup.mixed().nullable().required(),
    priority: yup.string().required(),
    departmentId: yup.string().nullable(),
    description: yup.string().nullable(),
    objective: yup.string().nullable(),
    ncOrigin: yup.string().required(),
    occurrenceDate: yup
      .date()
      .typeError('A data de ocorrência deve ser uma data válida')
      .required(),
    classification: yup.string().required(),
    rootCauseAnalysis: yup.string().required(),
    ncActions: yup.array().of(
      yup.object({
        correctiveAction: yup.string().required(),
        responsibleId: yup.mixed().nullable().required(),
        deadline: yup
          .date()
          .typeError('O prazo deve ser uma data válida')
          .required(),
        immediateAction: yup.string().nullable(),
        preventiveAction: yup.string().nullable(),
        effectivenessVerification: yup.string().nullable(),
        verificationDate: yup
          .date()
          .nullable()
          .typeError('A data deve ser uma data válida'),
        provenEffectiveness: yup.boolean().nullable(),
      }),
    ),
  })

export default schema
